import { Box } from "@mui/material";
import SarodiWhite from "../../images/sarodi-white.svg";
import { useEffect, useState } from "react";

const HomePageAnimation = () => {
  const [startAnimation, setStartAnimation] = useState<boolean>(false);
  const [hideHomePageAnimation, setHideHomePageAnimation] =
    useState<boolean>(false);
  const [removePage, setRemovePage] = useState<boolean>(false);
  const [firstTime, setFirstTime] = useState<boolean>(true);

  useEffect(() => {
    const isFirstTime = localStorage.getItem("FIRST_TIME_LOAD");

    if (!isFirstTime) {
      setStartAnimation(true);
    } else {
      setFirstTime(false);
    }

    const timer = setTimeout(() => {
      setHideHomePageAnimation(true);
    }, 2600);
    const timer2 = setTimeout(() => {
      setRemovePage(true);
      if (!isFirstTime)
        localStorage.setItem("FIRST_TIME_LOAD", JSON.stringify(false));
    }, 4000);

    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
    };
  }, []);

  return firstTime ? (
    <Box
      sx={{
        opacity: hideHomePageAnimation ? "0" : "1",
        transition: "all 2s",
        display: removePage ? "none" : "block",
        zIndex: "100",
        width: "100vw",
        height: "100dvh",
        backgroundColor: "rgba(0, 0, 0, .85)",
        backdropFilter: hideHomePageAnimation ? "none" : "blur(50px)",
        position: "fixed",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50)",
          top: startAnimation ? "0" : "-100%",
          transition: "all 1s 1s",
          background: "#fff",
          width: "3px",
          height: "45%",
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          opacity: startAnimation ? "1" : "0",
          transition: "all 2s 1s",
          transform: "translate(-50%, -50%)",
        }}
      >
        <img src={SarodiWhite} alt="Saroid icon." />
      </Box>
      <Box
        sx={{
          position: "absolute",
          left: "50%",
          transform: "translateX(-50)",
          bottom: startAnimation ? "0" : "-100%",
          transition: "all 1s",
          background: "#fff",
          width: "3px",
          height: "45%",
        }}
      />
    </Box>
  ) : null;
};

export default HomePageAnimation;
